import React, { useState, useEffect, useRef } from 'react';
import { useCCContext } from '../CC/CCContext';
import * as ccUtils from '../CC/utils';
import styles from './ObjSameTheme.module.css';
import ObjSameThemeIcon from './ObjSameThemeIcon';
import GenericIconButton from '../GenericComponents/GenericIconButton';

interface RecordProps {
    record: any; // Define a more specific type for your record
}

const ObjSameTheme: React.FC<RecordProps> = ({ record }) => {
    const [records, setRecords] = useState<any[]>([]);
    const filmStripRef = useRef<HTMLDivElement | null>(null);
    const ctx = useCCContext();

    const handleScrollLeft = () => {
        const filmStripElement = filmStripRef.current;
        filmStripElement && filmStripElement.scrollBy({
          left: -300,
          behavior: 'smooth'
        });
      };
    
      const handleScrollRight = () => {
        const filmStripElement = filmStripRef.current;
        filmStripElement && filmStripElement.scrollBy({
          left: 300,
          behavior: 'smooth'
        });
      };
    
    useEffect(() => {
        /*
        const normalizeToArray = (value: any) => {
            if (!value) return []; // Handle undefined or null values
            return Array.isArray(value) ? value : [value]; // Normalize to array
        };
        */
        if (filmStripRef.current) {
            filmStripRef.current.scrollLeft = 0;
          }
    
        const fetchTitles = async () => {
            var thesthemesArray
            thesthemesArray = Array.isArray(record.data.record.thesthemes)
            ? record.data.record.thesthemes
            : [record.data.record.thesthemes];
    
            const url = `${process.env.REACT_APP_CC_URL}/?action=get&command=search&query=and(/record/avecimage=Uniquement avec images;and(not(ccobjectid=${record.data.record.ccobjectid}));thesthemes=${thesthemesArray[0]})&fields=*&range=1-20&responseFormat=json`;
            console.log(url);
            try {
                const response = await fetch(url);
                const data = await response.json();
                let fetchedRecords: any[] = [];

                if (Array.isArray(data.records.record)) {
                    fetchedRecords = data.records.record;
                } else if (data.records.record) {
                    fetchedRecords = [data.records.record];
                }

                setRecords(fetchedRecords);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchTitles();
    }, [record]);

    const handleLinkClick = (event: React.MouseEvent, index: number) => {
        event.preventDefault();
        const ccobjectid = records[index]?.data?.record?.ccobjectid;


        ccUtils.customSearch(
          ctx,
          "/Record/ccobjectid",
          "",
          `[${ccobjectid}]`,
          `notice liées: ${ccobjectid}`
        );
        };

    return (
      
      <div>{records.length > 0 && <div>
      <p><b>Sur le même thème...</b></p>
            <div className={styles.filmStripContainer}>
                <div className={styles.buttonContainer}>
                  <GenericIconButton icon='light/angle-left.svg' width='22px' height='20px' onClick={handleScrollLeft} />
                </div>
                <div className={styles.filmStrip} ref={filmStripRef}>
                    {records.map((record: any, index: number) => (
                    <ObjSameThemeIcon
                        key={index}
                        record={record}
                        index={index}
                        handleLinkClick={handleLinkClick}
                    />
                    ))}
                </div>
                <div className={styles.buttonContainer}>
                  <GenericIconButton icon='light/angle-right.svg' width='22px' height='20px' onClick={handleScrollRight} />
                </div>
              </div></div>
}
              </div>
    );
};

export default ObjSameTheme;
